// polyfill TextEncoder for IE Edge
import { TextEncoder } from 'text-encoding';

// /* global window */
if (typeof TextEncoder === 'undefined') {
    //window.TextEncoder = TextEncoder;
}

/**
 * Guard against the React + browser-translation (Google/Chrome Translate) crash:
 * "Failed to execute 'insertBefore'/'removeChild' on 'Node': The node ... is not a child of this node."
 *
 * The in-browser translator replaces text nodes with <font> wrappers, so the DOM node
 * references React keeps become stale. When React later reconciles (e.g. navigating into
 * Surgery copy from order history) it calls insertBefore/removeChild against a parent that
 * no longer owns the reference node and throws NotFoundError, leaving a blank page.
 *
 * Making these operations defensive lets React fall back to appendChild instead of crashing.
 * Ref: https://github.com/facebook/react/issues/11538
 */
if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function removeChild(child) {
        if (child.parentNode !== this) {
            if (typeof console !== 'undefined' && console.warn) {
                console.warn('Cannot remove a child from a different parent', child, this);
            }
            return child;
        }
        // eslint-disable-next-line prefer-rest-params
        return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            if (typeof console !== 'undefined' && console.warn) {
                console.warn('Cannot insert before a reference node from a different parent', referenceNode, this);
            }
            return newNode;
        }
        // eslint-disable-next-line prefer-rest-params
        return originalInsertBefore.apply(this, arguments);
    };
}
